import React from "react";
import { useParams } from "react-router-dom";
import Preloader from "../helper/Preloader";

import ProductDetails from "../components/ProductDetails";
import NewArrival from "../components/NewArrival";
import Shipping from "../components/Shipping";
import Newsletter from "../components/Newsletter";
import Breadcrumb from '../components/Breadcrumb';
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";

const ProductDetailsPage = () => {
  const { id } = useParams();



  return (
    <>

      {/* Preloader */}
      <Preloader />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* Breadcrumb */}
      <Breadcrumb title={"Shop"} />

      {/* ProductDetails */}
      <ProductDetails productId={id} />

      {/* NewArrival */}
      <NewArrival />

      {/* Shipping */}
      <Shipping />

      {/* Newsletter */}
      <Newsletter />
    </>
  );
};

export default ProductDetailsPage;
